<span data-tooltip="{{tip}}" data-flow="top">
	<ng-content></ng-content>
</span>